__turbopack_context__.v({
  "buyside_widget_container": "styles-module-scss-module__YBQAXa__buyside_widget_container",
  "sell_with_sibcy": "styles-module-scss-module__YBQAXa__sell_with_sibcy",
  "sell_with_sibcy_background_image": "styles-module-scss-module__YBQAXa__sell_with_sibcy_background_image",
  "sell_with_sibcy_container": "styles-module-scss-module__YBQAXa__sell_with_sibcy_container",
});
